<template>
  <div
    v-if="mostrarModalFicha"
    @click.self="cerrarModalFicha"
    class="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto bg-gray-900 bg-opacity-50"
  >
    <div
      class="relative bg-white rounded-lg shadow dark:bg-gray-700 mx-4 sm:mx-auto w-full max-w-lg md:max-w-2xl p-6 overflow-auto max-h-screen"
    >
      <!-- Contenido para imprimir -->
      <div id="ficha-para-imprimir">
        <h2 class="text-xl font-bold text-center mb-4">
          Expediente del Cliente
        </h2>

        <div class="grid gap-4 md:grid-cols-2 grid-cols-subgrid">
          <div class="bg-white shadow-lg p-4 rounded-lg border">
            <p>Nombre completo : <br />{{ prospectoSeleccionado.fullName }}</p>
          </div>

          <div class="bg-white shadow-lg p-4 rounded-lg border">
            <p>Sexo : <br />{{ prospectoSeleccionado.sexo }}</p>
          </div>

          <div class="bg-white shadow-lg p-4 rounded-lg border">
            <p>
              Fecha de nacimiento : <br />{{
                prospectoSeleccionado.fechaNacimiento
              }}
            </p>
          </div>

          <div class="bg-white shadow-lg p-4 rounded-lg border">
            <p>Dirección : <br />{{ prospectoSeleccionado.direccion }}</p>
          </div>

          <div class="bg-white shadow-lg p-4 rounded-lg border">
            <p>Correo Electrónico : <br />{{ prospectoSeleccionado.email }}</p>
          </div>

          <div class="bg-white shadow-lg p-4 rounded-lg border">
            <p>Teléfono : <br />{{ prospectoSeleccionado.telefono }}</p>
          </div>

          <div class="bg-white shadow-lg p-4 rounded-lg border">
            <p>
              Licencia del Cliente : <br />{{
                prospectoSeleccionado.licenciaCliente
              }}
            </p>
          </div>

          <div class="bg-white shadow-lg p-4 rounded-lg border">
            <p>
              Licencia del Responsable : <br />{{
                prospectoSeleccionado.respLicencia
              }}
            </p>
          </div>

          <div class="bg-white shadow-lg p-4 rounded-lg border">
            <p>
              Parentesco del Responsable : <br />{{
                prospectoSeleccionado.respParentesco
              }}
            </p>
          </div>

          <div class="bg-white shadow-lg p-4 rounded-lg border">
            <p>Edad : <br />{{ prospectoSeleccionado.edad }}</p>
          </div>

          <div class="bg-white shadow-lg p-4 rounded-lg border">
            <p>
              Alérgic@ a comidas y/o medicamentos : <br />{{
                prospectoSeleccionado.alergiasComidasMeds
              }}
            </p>
          </div>

          <div class="bg-white shadow-lg p-4 rounded-lg border">
            <p>
              Tratamientos o cirugías recientes : <br />{{
                prospectoSeleccionado.tratamientosCirugias
              }}
            </p>
          </div>

          <div class="bg-white shadow-lg p-4 rounded-lg border">
            <p>
              Medicamentos que está utilizando : <br />{{
                prospectoSeleccionado.medicamentos
              }}
            </p>
          </div>

          <div class="bg-white shadow-lg p-4 rounded-lg border">
            <p>
              ¿Ha recibido tratamientos en el área a tratar? : <br />{{
                prospectoSeleccionado.tratamientosArea
              }}
            </p>
          </div>

          <div class="bg-white shadow-lg p-4 rounded-lg border">
            <p>
              Detalles de tratamientos en el área : <br />{{
                prospectoSeleccionado.detalleTratamientosArea
              }}
            </p>
          </div>

          <div class="bg-white shadow-lg p-4 rounded-lg border">
            <p>
              Último tratamiento : <br />{{
                prospectoSeleccionado.ultimoTratamiento
              }}
            </p>
          </div>

          <div class="bg-white shadow-lg p-4 rounded-lg border">
            <p>
              Motivo de consulta : <br />{{
                prospectoSeleccionado.motivoConsulta
              }}
            </p>
          </div>

          <div class="bg-white shadow-lg p-4 rounded-lg border">
            <p>
              Servicio solicitado : <br />{{ prospectoSeleccionado.servicio }}
            </p>
          </div>
        </div>

        <!-- Sección para información del médico (solo visible al imprimir) -->
        <div class="print-only mt-8">
          <h3 class="text-lg font-bold text-center mb-4">
            Información del Médico
          </h3>

          <div class="mb-4">
            <p class="font-semibold mb-2">Revisado por:</p>
            <div class="h-8 border-b"></div>
          </div>

          <div class="mb-4">
            <p class="font-semibold mb-2"># Licencia:</p>
            <div class="h-8 border-b"></div>
          </div>

          <div class="mb-4">
            <p class="font-semibold mb-2">Fecha de revisión:</p>
            <div class="h-8 border-b"></div>
          </div>

          <div class="mb-4">
            <p class="font-semibold mb-2">Firma:</p>
            <div class="h-16 border-b"></div>
          </div>
        </div>
      </div>

      <div class="flex justify-end space-x-4 mt-6">
        <button
          @click="imprimirFicha"
          type="button"
          class="px-4 py-2 text-sm font-medium text-white bg-green-600 rounded-lg hover:bg-green-700 focus:ring-4 focus:ring-green-300 dark:focus:ring-green-700 dark:bg-green-600 dark:text-white"
        >
          Imprimir
        </button>
        <button
          @click="cerrarModalFicha"
          type="button"
          class="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-lg hover:bg-gray-300 focus:ring-4 focus:ring-gray-300 dark:focus:ring-gray-700 dark:bg-gray-600 dark:text-white"
        >
          Cerrar
        </button>
      </div>
    </div>
  </div>
  <section class="bg-white dark:bg-gray-900">
    <div class="flex flex-col px-4 sm:px-6 lg:px-8">
      <h2
        class="mb-4 text-xl font-bold text-gray-900 dark:text-white text-center"
      >
        Gestión de Prospectos
      </h2>

      <div class="">
        <div class="">
          <label class="">Estado:</label>
          <select
            v-model="filterEstado"
            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          >
            <option selected :value="false">Pendiente</option>
            <!-- <option selected :value="true">Aprobado</option> -->
          </select>
        </div>
        <label
          for="buscar"
          class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
          >Buscar por nombre o apellido</label
        >
        <input
          v-model="filtro"
          type="text"
          id="buscar"
          class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
          placeholder="Buscar cliente..."
        />
      </div>

      <div class="mt-8">
        <h2
          class="text-xl font-bold text-gray-900 dark:text-white mb-4 text-center"
        >
          Lista Prospectos
        </h2>
        <div class="relative overflow-x-auto shadow-md sm:rounded-lg">
          <table
            class="w-full text-sm text-left text-gray-500 dark:text-gray-400"
          >
            <thead
              class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400 sticky top-0"
            >
              <tr>
                <th scope="col" class="px-6 py-3">Nombre</th>
                <th scope="col" class="px-6 py-3">Apellido</th>
                <th scope="col" class="px-6 py-3">Dirección</th>
                <th scope="col" class="px-6 py-3">Teléfono</th>
                <th scope="col" class="px-6 py-3">Email</th>
                <th scope="col" class="px-6 py-3">Ficha</th>
                <th scope="col" class="px-6 py-3">Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="paciente in filtrarPacientes"
                :key="paciente.id"
                class="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
              >
                <td
                  class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                >
                  {{ paciente.nombre }}
                </td>
                <td
                  class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                >
                  {{ paciente.apellido }}
                </td>
                <td class="px-6 py-4">{{ paciente.direccion }}</td>
                <td class="px-6 py-4">{{ paciente.telefono }}</td>
                <td class="px-6 py-4">{{ paciente.email }}</td>
                <td class="px-6 py-4">
                  <button
                    @click="abrirModalFicha(paciente)"
                    class="text-white w-full bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-xs px-3 py-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  >
                    Ver
                  </button>
                </td>
                <td
                  class="px-6 py-4 space-x-2 flex flex-col w-full items-end gap-3"
                >
                  <button
                    @click="manejarSet(paciente)"
                    v-if="paciente.activo !== true"
                    class="text-white w-full bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-xs px-3 py-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  >
                    Set
                  </button>
                  <button
                    @click="eliminarProspecto(paciente.id)"
                    class="text-white w-full bg-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-xs px-3 py-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800"
                  >
                    Eliminar
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {
  collection,
  getDocs,
  setDoc,
  updateDoc,
  addDoc,
  doc,
  query,
  where,
  serverTimestamp,
  deleteDoc,
  getDoc,
} from "firebase/firestore";
import { db, firebaseConfig } from "../../firebase"; // Asegúrate de que esta es la ruta correcta a tu archivo firebase.js
import { getFunctions, httpsCallable } from "firebase/functions"; // Importar funciones para invocar Cloud Functions
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth"; // Importar auth para autenticación
import { fetchSignInMethodsForEmail } from "firebase/auth";
import { initializeApp, deleteApp } from "firebase/app";
import eventBus from "@/utils/eventBus";

export default {
  data() {
    return {
      mostrarModalFicha: false,
      pacientes: [],
      pacientesFiltrados: [],
      filtro: "",
      prospectoSeleccionado: {},
      filterEstado: false,
    };
  },
  computed: {
    filtrarPacientes() {
      const filtroTexto = (this.filtro || "").toLowerCase();

      return this.pacientes.filter((paciente) => {
        const nombrePaciente = (paciente.nombre || "").toLowerCase();
        const apellidoPaciente = (paciente.apellido || "").toLowerCase();

        const coincideTexto =
          nombrePaciente.includes(filtroTexto) ||
          apellidoPaciente.includes(filtroTexto);

        const esPendiente = this.filterEstado === false;

        const esFlujo2 =
          paciente.fuente !== "solicitudLaser" &&
          paciente.aprobado !== true &&
          paciente.activo !== true;

        const esFlujo1Pendiente =
          paciente.fuente === "solicitudLaser" &&
          paciente.solicitudLaserPendiente === true &&
          paciente.activo !== true;

        const coincideEstado = esPendiente && (esFlujo2 || esFlujo1Pendiente);

        return coincideTexto && coincideEstado;
      });
    },
  },
  methods: {

    async aprobarSolicitudLaser(pacienteId) {
      const q = query(
        collection(db, "solicitudesLaser"),
        where("pacienteId", "==", pacienteId),
        where("estado", "==", "pendiente")
      );
      const snap = await getDocs(q);

      for (const docSnap of snap.docs) {
        const solicitudRef = doc(db, "solicitudesLaser", docSnap.id);
        await updateDoc(solicitudRef, {
          estado: "aprobado",
          actualizado: serverTimestamp(),
        });
      }
    },

    async crearSolicitudLaser(pacienteId) {
      if (!pacienteId) return;

      // ¿ya hay una pendiente/en_revision?
      const qRef = query(
        collection(db, "solicitudesLaser"),
        where("pacienteId", "==", pacienteId),
        where("estado", "in", ["pendiente", "en_revision"])
      );
      const snap = await getDocs(qRef);

      if (snap.empty) {
        await addDoc(collection(db, "solicitudesLaser"), {
          pacienteId,
          estado: "pendiente",
          creado: serverTimestamp(),
        });
      }

      await updateDoc(doc(db, "pacientes", pacienteId), {
        solicitudLaserPendiente: true,
        activo: true,
        status: "activo",
      });
    },

    imprimirFicha() {
      // Crear un nuevo elemento que contendrá solo lo que queremos imprimir
      const contenidoImprimir = document.getElementById(
        "ficha-para-imprimir"
      ).innerHTML;

      // Crear una ventana de impresión
      const ventanaImpresion = window.open("", "_blank");
      ventanaImpresion.document.write(`
        <html>
          <head>
            <title>Ficha del Paciente - ${this.prospectoSeleccionado.nombre} ${this.prospectoSeleccionado.apellido}</title>
            <style>
              body {
                font-family: Arial, sans-serif;
                padding: 20px;
              }
              .grid {
                display: grid;
                grid-template-columns: repeat(2, 1fr);
                gap: 10px;
              }
              .bg-white {
                background-color: white;
                border: 1px solid #e2e8f0;
                border-radius: 8px;
                padding: 10px;
                margin-bottom: 10px;
              }
              h2, h3 {
                text-align: center;
                margin-bottom: 20px;
              }
              .print-only {
                display: block;
              }
              .font-semibold {
                font-weight: 600;
              }
              .mb-2 {
                margin-bottom: 8px;
              }
              .mb-4 {
                margin-bottom: 16px;
              }
              .h-8 {
                height: 32px;
              }
              .h-16 {
                height: 64px;
              }
              .border-b {
                border-bottom: 1px solid #a0aec0;
              }
              @media print {
                body {
                  -webkit-print-color-adjust: exact;
                  print-color-adjust: exact;
                }
              }
            </style>
          </head>
          <body>
            ${contenidoImprimir}
          </body>
        </html>
      `);

      ventanaImpresion.document.close();

      // Esperar a que el contenido se cargue antes de imprimir
      ventanaImpresion.onload = function () {
        ventanaImpresion.print();
        // ventanaImpresion.close(); // Opcional: cerrar después de imprimir
      };
    },

    async abrirModalFicha(prospecto) {
      this.prospectoSeleccionado = prospecto;
      this.mostrarModalFicha = true;
    },
    cerrarModalFicha() {
      this.prospectoSeleccionado = {};
      this.mostrarModalFicha = false;
    },

    // Método para generar una contraseña aleatoria de 8 caracteres
    generarContraseñaAleatoria() {
      const caracteres =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@$*";
      let contraseña = "";
      for (let i = 0; i < 8; i++) {
        const indiceAleatorio = Math.floor(Math.random() * caracteres.length);
        contraseña += caracteres[indiceAleatorio];
      }
      return contraseña;
    },
    async registerNewUser(email, password) {
      const secondaryApp = initializeApp(firebaseConfig, "Secondary");
      try {
        const secondaryAuth = getAuth(secondaryApp);

        // Crea el usuario en la app secundaria
        const userCredential = await createUserWithEmailAndPassword(
          secondaryAuth,
          email,
          password
        );

        // Elimina la app secundaria
        await deleteApp(secondaryApp);

        return userCredential.user; // Devuelve el UID del usuario creado
      } catch (error) {
        console.error("Error creando usuario:", error);

        // Asegúrate de eliminar la app secundaria incluso si hay un error
        await deleteApp(secondaryApp);

        throw error; // Relanza el error para manejarlo en el componente
      }
    },
    async acortarUrl(url) {
      try {
        const response = await fetch(
          `https://tinyurl.com/api-create.php?url=${encodeURIComponent(url)}`
        );
        if (!response.ok) {
          throw new Error("Error al acortar la URL");
        }
        const urlAcortada = await response.text();
        return urlAcortada;
      } catch (error) {
        console.error("Error al acortar la URL:", error);
        throw error;
      }
    },
    async crearPaciente(paciente) {
      const auth = getAuth();

      try {
        const temporalId = paciente.id;
        const emailRaw = (paciente.email || "").trim();
        const emailNorm = emailRaw.toLowerCase();
        const quiereLaser = paciente.servicio === "depilacion_laser";

        // 1. Primer chequeo: ¿existe en Auth?
        let methods = await fetchSignInMethodsForEmail(auth, emailNorm);
        if (methods && methods.length > 0) {
          // No crear usuario
          const pacienteId = await this.findPacienteIdPorEmail(emailRaw);
          if (!pacienteId) {
            alert("El correo ya existe, pero no encontramos la ficha.");
            return;
          }

          if (quiereLaser) {
            const snap = await getDoc(doc(db, "pacientes", pacienteId));
            if (!snap.data()?.solicitudLaserPendiente) {
              await this.crearSolicitudLaser(pacienteId);
              alert("Solicitud láser enviada. Pendiente de aprobación.");
            } else {
              alert("Ya tienes una solicitud pendiente.");
            }
          } else {
            alert("Paciente ya registrado. Activando ficha.");
          }

          await updateDoc(doc(db, "pacientes", pacienteId), {
            activo: true,
            status: "activo",
            role: "paciente",
            emailLower: emailNorm,
          });

          if (temporalId) {
            await updateDoc(doc(db, "prospectos", temporalId), {
              activo: true,
            });
          }

          this.cargarPacientes?.();
          return;
        }

        // 2. Segundo chequeo de seguridad
        methods = await fetchSignInMethodsForEmail(auth, emailNorm);
        if (methods && methods.length > 0) {
          alert("Este correo ya existe. Abortando creación.");
          return;
        }

        // 3. Crear paciente nuevo
        const temporalPassword = this.generarContraseñaAleatoria();
        const user = await this.registerNewUser(emailNorm, temporalPassword);

        delete paciente.id;
        await setDoc(doc(db, "pacientes", user.uid), {
          ...paciente,
          email: emailRaw,
          emailLower: emailNorm,
          uid: user.uid,
          role: "paciente",
          activo: true,
          status: "activo",
        });

        if (quiereLaser && paciente.fuente === "solicitudLaser") {
          await this.crearSolicitudLaser(user.uid);
        }

        if (temporalId)
          await updateDoc(doc(db, "prospectos", temporalId), { activo: true });

        const enviarCorreo = httpsCallable(
          getFunctions(),
          "enviarCorreoPaciente"
        );
        await enviarCorreo({
          email: emailRaw,
          nombre: paciente.nombre,
          apellido: paciente.apellido,
          pacienteId: user.uid,
          temporalPassword,
        });

        const sendSms = httpsCallable(getFunctions(), "sendSms");
        const link = `https://nat-spa.web.app/registro/crear-cuenta/${
          user.uid
        }?email=${encodeURIComponent(emailRaw)}&pas=${encodeURIComponent(
          temporalPassword
        )}`;

        const shortUrl = await this.acortarUrl(link);

        const tel = (paciente.telefono ?? "").toString();
        const to = tel ? (tel.startsWith("+1") ? tel : `+1${tel}`) : "";
        if (to) {
          await sendSms({
            message: `Bienvenido a Nat Spa\nHola ${paciente.nombre}\nCuenta creada. Contraseña temporal: ${temporalPassword}\nRegistra tu cuenta: ${shortUrl}`,
            to,
          });
        }

        this.cargarPacientes?.();
        alert("Paciente Creado");
      } catch (e) {
        if (String(e).includes("auth/email-already-in-use")) {
          alert("El correo ya existe. No crear nuevamente.");
          return;
        }
        console.error("Error en crearPaciente:", e);
        alert("Ocurrió un error creando o vinculando el paciente.");
      }
    },

    async eliminarProspecto(id) {
      if (!id) {
        console.error("El ID del prospecto no es válido:", id);
        alert(
          "Hubo un problema al intentar eliminar el prospecto. Por favor, inténtalo de nuevo."
        );
        return;
      }

      if (confirm("¿Estás seguro de eliminar este prospecto?")) {
        try {
          // await deleteUser(user)
          await deleteDoc(doc(db, "prospectos", id));

          // Actualizar el array local eliminando el prospecto con el ID correspondiente
          this.pacientes = this.pacientes.filter(
            (paciente) => paciente.id !== id
          );

          alert("Prospecto eliminado con éxito");
        } catch (e) {
          console.error("Error al eliminar el prospecto:", e);
          alert("Hubo un error al eliminar el prospecto.");
        }
      }
    },

    async findPacienteIdPorEmail(email) {
      const emailNorm = (email || "").trim().toLowerCase();

      // Buscar por campo indexado si existe
      const q = query(
        collection(db, "pacientes"),
        where("emailLower", "==", emailNorm)
      );
      const snap = await getDocs(q);
      if (!snap.empty) return snap.docs[0].id;

      // Fallback: buscar a mano si no hay índice
      const all = await getDocs(collection(db, "pacientes"));
      for (const docu of all.docs) {
        const data = docu.data();
        if ((data.email || "").trim().toLowerCase() === emailNorm) {
          return docu.id;
        }
      }

      return null;
    },

    async manejarSet(paciente) {
      const email = (paciente.email || "").trim().toLowerCase();
      let pacienteId = paciente.id;

      // Si no hay ID, buscar por email (flujo 2)
      if (!pacienteId && email) {
        pacienteId = await this.findPacienteIdPorEmail(email);
      }

      // Si no se encontró, crear nuevo (flujo 2 desde cero)
      if (!pacienteId) {
        console.log("❌ No se encontró pacienteId ni por ID ni por email.");
        return this.crearPaciente(paciente);
      }

      // Obtener ficha del paciente
      const snap = await getDoc(doc(db, "pacientes", pacienteId));

      // ⚠️ Si existe Auth pero no ficha => flujo 2 incompleto → crear ficha
      if (!snap.exists()) {
        console.warn(
          "⚠️ Existe Auth pero no ficha. Se creará ficha desde flujo 2."
        );
        return this.crearPaciente(paciente);
      }

      const ficha = snap.data();

      // ✅ Paciente ya activo
      if (ficha.activo === true) {
        // 🔐 Solo aplicar flujo 1 si la fuente lo confirma explícitamente
        if (
          ficha.solicitudLaserPendiente === true &&
          paciente.fuente === "solicitudLaser"
        ) {
          console.log(
            "✔️ Paciente activo del flujo 1. Buscando solicitudes láser pendientes..."
          );
          console.log("pacienteId buscado:", pacienteId);

          const q = query(
            collection(db, "solicitudesLaser"),
            where("pacienteId", "==", pacienteId),
            where("estado", "==", "pendiente")
          );

          const solicitudesSnap = await getDocs(q);

          console.log("📦 Solicitudes encontradas:", solicitudesSnap.size);
          solicitudesSnap.forEach((doc) => {
            console.log("🔍 Solicitud:", doc.id, doc.data());
          });

          if (solicitudesSnap.empty) {
            alert(
              "No se encontraron solicitudes pendientes aunque el flag estaba activo."
            );
            return;
          }

          // ✅ Aprobar solicitudes
          for (const docSnap of solicitudesSnap.docs) {
            await updateDoc(doc(db, "solicitudesLaser", docSnap.id), {
              estado: "aprobado",
              actualizado: serverTimestamp(),
            });
            console.log("🟢 Estado actualizado: aprobado →", docSnap.id);
          }

          // ✅ Actualizar ficha paciente
          await updateDoc(doc(db, "pacientes", pacienteId), {
            solicitudLaserPendiente: false,
            servicio: "depilacion_laser",
            activo: true,
            status: "activo",
          });

          alert("Solicitud aprobada. Paciente activado.");
          this.cargarPacientes?.();

          // ✅ Emitir evento solo si es flujo 1
          eventBus.emit("solicitudesLaserActualizadas");
          return;
        }

        // 🔕 Es un paciente activo que no pertenece al flujo de solicitudesLaser
        console.warn(
          "⛔️ Paciente activo pero no es del flujo 1. Nada que hacer aquí."
        );
        alert("Este paciente ya está aprobado y activo.");
        return;
      }

      // Paciente no estaba activo → activarlo
      await setDoc(
        doc(db, "pacientes", pacienteId),
        {
          activo: true,
          status: "activo",
          servicio: "depilacion_laser",
        },
        { merge: true }
      );

      eventBus.emit("flujo2Actualizado");

      // Si viene desde prospectos, actualizar también
      if (paciente.id) {
        await setDoc(
          doc(db, "prospectos", paciente.id),
          {
            activo: true,
          },
          { merge: true }
        );
      }

      // 🚫 Cortar totalmente si no es del flujo 1 REAL
      if (
        ficha.solicitudLaserPendiente !== true ||
        paciente.fuente !== "solicitudLaser"
      ) {
        console.log(
          "🚫 Paciente no es del flujo 1 real. No ejecutar lógica de solicitud."
        );

        // 🔥 Borra la solicitud láser si existe por error
        const solicitudErronea = await getDocs(
          query(
            collection(db, "solicitudesLaser"),
            where("pacienteId", "==", pacienteId)
          )
        );
        for (const docu of solicitudErronea.docs) {
          await updateDoc(doc(db, "solicitudesLaser", docu.id), {
            estado: "anulada_por_flujo2",
            nota: "Removida por ejecución desde flujo 2",
          });
          console.warn(
            "🚫 Solicitud láser anulada por ejecución en flujo 2:",
            docu.id
          );
        }
        
        return;
      }

      const q = query(
        collection(db, "solicitudesLaser"),
        where("pacienteId", "==", pacienteId),
        where("estado", "==", "pendiente")
      );
      const solicitudesSnap = await getDocs(q);

      if (!solicitudesSnap.empty) {
        for (const docSnap of solicitudesSnap.docs) {
          await updateDoc(doc(db, "solicitudesLaser", docSnap.id), {
            estado: "aprobado",
            actualizado: serverTimestamp(),
          });
          console.log("✅ Solicitud aprobada (post-activación):", docSnap.id);
        }

        // 🔔 Emitir solo si hubo solicitud aprobada
        eventBus.emit("solicitudesLaserActualizadas");
      }

      // ✅ Siempre limpiar flag después
      await updateDoc(doc(db, "pacientes", pacienteId), {
        solicitudLaserPendiente: false,
      });

      // NUEVO BLOQUE: Generar link de activación si no tiene cuenta en Auth
      const auth = getAuth();
      const methods = await fetchSignInMethodsForEmail(auth, email);
      const tieneAuthUser = methods && methods.length > 0;

      if (!tieneAuthUser) {
        const temporalPassword = this.generarContraseñaAleatoria();
        const user = await this.registerNewUser(email, temporalPassword);

        // Crear ficha completa en pacientes/{uid}
        await setDoc(
          doc(db, "pacientes", user.uid),
          {
            ...paciente, // datos básicos que ya tenías en el prospecto
            uid: user.uid,
            email: email,
            emailLower: email.toLowerCase(),
            role: "paciente",
            activo: true,
            status: "activo",
            passwordTemporal: true, // opcional, marca que debe cambiar su clave
          },
          { merge: true }
        );

        if (paciente.fuente === "solicitudLaser") {
          await this.crearSolicitudLaser(user.uid);
        }
        //  Generar link de activación
        const base = `https://nat-spa.web.app/registro/crear-cuenta/${user.uid}`;
        const u = new URL(base);
        u.searchParams.set("email", email);
        u.searchParams.set("pas", temporalPassword);
        const longUrl = u.toString();

        // Acortar URL
        const shortUrl = await this.acortarUrl(longUrl);

        // 📲 Enviar SMS si tiene teléfono
        const tel = (paciente.telefono ?? "").toString();
        const to = tel ? (tel.startsWith("+1") ? tel : `+1${tel}`) : "";

        if (to) {
          const sendSms = httpsCallable(getFunctions(), "sendSms");
          await sendSms({
            message: `Bienvenido a Nat Spa\nHola ${paciente.nombre}\nCuenta activada. Contraseña temporal: ${temporalPassword}\nRegistra tu cuenta: ${shortUrl}`,
            to,
          });
        }

        //  Enviar correo
        const enviarCorreo = httpsCallable(
          getFunctions(),
          "enviarCorreoPaciente"
        );
        await enviarCorreo({
          email,
          nombre: paciente.nombre,
          apellido: paciente.apellido,
          pacienteId: user.uid,
          temporalPassword,
        });
      }

      //  Forzar ocultar notificación
      this.laserPendientesCount = 0;
      this.showLaserToast = false;

      alert("Paciente activado con éxito.");
      this.cargarPacientes?.();
    },

    async cargarPacientes() {
      try {
        console.log(" Cargando prospectos y pacientes del flujo 1...");

        // 1️ Cargar prospectos no aprobados
        const prospectosSnap = await getDocs(collection(db, "prospectos"));
        const prospectos = prospectosSnap.docs
          .map((doc) => ({ id: doc.id, ...doc.data() }))
          .filter((p) => p.aprobado !== true);

        console.log(" Prospectos cargados:", prospectos.length);

        // 2️ Cargar solicitudes láser pendientes (flujo 1)
        const solicitudesSnap = await getDocs(
          query(
            collection(db, "solicitudesLaser"),
            where("estado", "==", "pendiente")
          )
        );

        const pacientesExtras = [];

        for (const solicitudDoc of solicitudesSnap.docs) {
          const solicitud = solicitudDoc.data();
          const pacienteId = solicitud.pacienteId;

          // Saltar si ya está en prospectos
          if (prospectos.some((p) => p.id === pacienteId)) continue;

          const pacienteSnap = await getDoc(doc(db, "pacientes", pacienteId));
          if (!pacienteSnap.exists()) continue;

          const ficha = pacienteSnap.data();
          if (!ficha) continue;

          if (ficha.solicitudLaserPendiente !== true) {
            continue;
          }

          console.log("✔️ Agregando paciente del flujo láser:", pacienteId);

          pacientesExtras.push({
            id: pacienteId,
            nombre: ficha?.nombre ?? "Sin nombre",
            apellido: ficha?.apellido ?? "Sin apellido",
            direccion: ficha?.direccion ?? "",
            telefono: ficha?.telefono ?? "",
            email: ficha?.email ?? "",
            activo: false,
            aprobado: false,
            servicio: "depilacion_laser",
            fuente: "solicitudLaser",
            solicitudLaserPendiente: true,
          });
        }

        console.log(
          " Pacientes extra desde solicitudes:",
          pacientesExtras.length
        );

        // 3️ Combinar todo
        this.pacientes = [...prospectos, ...pacientesExtras];

        console.log(
          " Total pacientes cargados en tabla:",
          this.pacientes.length
        );
      } catch (e) {
        console.error(" Error al cargar los pacientes:", e);
        alert("Hubo un error al cargar los pacientes.");
      }
    },
  },

  async mounted() {
    this.cargarPacientes();
  },
};
</script>

<style scoped>
@media (max-width: 768px) {
  .modal-content {
    max-height: 80vh;
    /* Limita el alto del modal */
    overflow-y: auto;
    /* Habilita desplazamiento vertical */
  }
}

/* Estilos para impresión */
@media print {
  .print-only {
    display: block !important;
  }

  button {
    display: none !important;
  }
}

/* Ocultar sección del médico en pantalla */
.print-only {
  display: none;
}
</style>
